import { TabProps } from "@mui/material";
import { type FC, useRef, useState } from "react";
import { createRoot } from "react-dom/client";
declare global {
  interface Window {
    agenda_tabs: any[];
  }
}

interface AccordionTabProps {
  tab: SingleTabInAccordion;
}

interface SingleTabInAccordion {
  label: string;
  content: string;
}
window.agenda_tabs = window.agenda_tabs || [];

const Tab: FC<AccordionTabProps> = ({ tab }: { tab: any }) => {
  const [open, setOpen] = useState<boolean>(false);
  const heightref: any = useRef(null);
  return (
    <div
      className="tab"
      onClick={(e) => {
        setOpen(!open);
      }}
    >
      <div className="tab-wrapper">
        <label className="data-label">{tab.label}</label>
        <div className="dropdown-icon">
          <button aria-expanded={open}>
            <span className="sr-only">Open Accordion Tab</span>
            <svg className="bi bi-chevron-down" width="40" height="40" viewBox="0 0 16 16">
              <path
                fillRule="evenodd"
                d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
              />
            </svg>
          </button>
        </div>
      </div>
      <div
        style={{
          opacity: open ? 1 : 0,
          height: open
            ? heightref.current
              ? heightref.current.offsetHeight
              : "auto"
            : 0,
          overflowY: open ? "visible" : "hidden",
        }}
        className={"tab-content"}
      >
        <div
          ref={heightref}
          className="data-content"
          dangerouslySetInnerHTML={{ __html: tab.content }}
        />
      </div>
    </div>
  );
};

const Accordion: FC<{
  data: {
    label: string;
    content: string;
  }[];
}> = ({ data = [] }) => {
  return (
    <div className="accordion-outmost-wrapper">
      {data?.map((d: SingleTabInAccordion, i: number) => (
        <Tab key={`tab-${i}`} tab={d} />
      ))}
    </div>
  );
};

document.addEventListener("DOMContentLoaded", () => {
  if (window.agenda_tabs.length <= 0) {
    return;
  }

  for (let i = 0; i < window.agenda_tabs.length; i++) {
    const item = window.agenda_tabs[i];
    const data: SingleTabInAccordion[] = [
      // Wrap the data object inside an array
      {
        label: item.label,
        content: item.content,
      },
    ];

    const el = document.getElementById(item.scope);
    if (!el) {
      continue;
    }
    const root = createRoot(el);
    root.render(<Accordion data={data} />);
  }
});

export { };
